'use strict';
const nodeDragMimeType = 'vnd/mindmup-node',
	observable = require('@mindmup/mapjs-core/src/util/observable'),
	shadowDraggable = require('./shadow-draggable'),
	uniqueString = require('@mindmup/js-utils/src/unique-string');
module.exports = function DraggableNodeController(stage) {
	let dragNonce,
		draggingNodeId;
	const self = observable(this),
		getDraggedNodeData = (evt) => {
			const dataString = evt.dataTransfer.getData(nodeDragMimeType),
				data = dataString && JSON.parse(dataString);
			if (data && data.dragNonce === dragNonce) {
				return data;
			}
			return false;
		};
	if (!stage) {
		throw new Error('invalid-args');
	}
	stage.getDOMElement().addEventListener('dragover', (evt) => {
		if (draggingNodeId) {
			evt.preventDefault();
			evt.dataTransfer.dropEffect = 'move';
			self.dispatchEvent('nodeDraggedOnStage', draggingNodeId, evt);
		}
	});
	stage.getDOMElement().addEventListener('drop', (evt) => {
		const data = getDraggedNodeData(evt);
		if (data) {
			evt.preventDefault();
			self.dispatchEvent('nodeDroppedOnStage', data, evt);
		}
	});
	stage.getDOMElement().addEventListener('dragleave', e => {
		// TODO: check if we need to restrict this to say only
		// a node being dragged?
		self.dispatchEvent('nodeDraggedOutOfStage', e);
	});
	self.makeNodeDraggable = (domElement, node) => {
		domElement.addEventListener('dragstart', e => {
			const boundingRect = domElement.getBoundingClientRect(),
				scale = stage.getStageData().scale,
				clientX = e.clientX,
				clientY = e.clientY,
				insetX = (clientX - boundingRect.x) / scale,
				insetY = (clientY - boundingRect.y) / scale;

			draggingNodeId = node.id;
			dragNonce = uniqueString();
			domElement.classList.add('dragging');
			e.dataTransfer.setData(
				nodeDragMimeType,
				JSON.stringify({nodeId: node.id, insetX, insetY, dragNonce})
			);
			self.dispatchEvent('nodeDragStarted', node.id);
		});
		domElement.addEventListener('dragend', function () {
			dragNonce = false;
			draggingNodeId = false;
			domElement.classList.remove('dragging');
			self.dispatchEvent('nodeDragEnded', node.id);
		});
		domElement.addEventListener('drop', (evt) => {
			const data = getDraggedNodeData(evt);
			if (data && data.nodeId !== node.id) {
				self.dispatchEvent('nodeDroppedOnNode', data.nodeId, node.id, evt);
				evt.preventDefault();
				evt.stopPropagation();
			}
			domElement.classList.remove('droppable');
		});
		domElement.addEventListener('dragover', (e) => {
			if (draggingNodeId && draggingNodeId !== node.id) {
				domElement.classList.add('droppable');
				e.preventDefault();
				e.stopPropagation();
			}
		});
		domElement.addEventListener('dragleave', () => {
			domElement.classList.remove('droppable');
		});
		shadowDraggable(domElement, stage);
	};
};
